import { EditableVenueMembershipProgram, MembershipProgram } from "../types";

import { scaffoldEdit } from "common/scaffolding/reducers/scaffoldEdit";

export enum TypeKeys {
    FETCH_BEGIN = "MEMBERSHIPS/FETCH_EDITABLE_BEGIN",
    FETCH_SUCCESS = "MEMBERSHIPS/FETCH_EDITABLE_SUCCESS",
    FETCH_FAILURE = "MEMBERSHIPS/FETCH_EDITABLE_FAILURE",

    SAVE_BEGIN = "MEMBERSHIPS/SAVE_EDITABLE_BEGIN",
    SAVE_SUCCESS = "MEMBERSHIPS/SAVE_EDITABLE_SUCCESS",
    SAVE_FAILURE = "MEMBERSHIPS/SAVE_EDITABLE_FAILURE",
}

const edit = scaffoldEdit<EditableVenueMembershipProgram, MembershipProgram, typeof TypeKeys>(TypeKeys);
const { createAction, reducer } = edit;

export type State = ReturnType<typeof edit.reducer>;
export { createAction, reducer };

export type SavedAction = ReturnType<typeof createAction.saved>;
